import { render } from "./view-form.vue?vue&type=template&id=0fa4d358"
import script from "./view-form.vue?vue&type=script&lang=js"
export * from "./view-form.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\BijouCRM\\src\\ui\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__